import angular from 'angular';

angular.module('webTools').directive('wtUploadProgress', ['$rootScope', '$compile', '$timeout', '$templateCache', 'File',
function ($rootScope, $compile, $timeout, $templateCache, File) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            template: '<div class="progress-window">' +
                            '<div class="progress-window-header">' +
                                '<span>Importing {{flowObject.files.length}} files</span>' +
                                '<div class="upload-progress" style="background-color: #fff">' +
                                    '<div style="height:100%" ng-style="{width : (flowObject.progress() * 100) + \'%\'}"  ng-class="file.isComplete() ? \'progress-complete\' : \'progress-active\'"></div>' +
                                '</div>' +
                            '</div>' +
                            '<ul class="upload-progress-list">' +
                                '<li ng-repeat="file in flowObject.files">' +
                                '<div ng-style="{width : (file.progress() * 100) + \'%\'}" class="file-progress" ng-class="file.isComplete() ? \'progress-complete\' : \'progress-active\'"></div>' +
                                    '<div style="position:relative;width:100%;height:100%;z-index:10;padding-right: 85px;box-sizing: border-box">' +
                                        '<div class="file-icon-small files-small-{{file.name.split(\'.\').pop();}}" style="margin:5px 0 0 5px;"></div>' +
                                        '<span class="upload-filename">{{file.name}}</span>' +
                                        '<span style="position:absolute;right:10px;top:8px;">{{fileService.getReadableFileSize(file.size)}}</span>' +
                                    '</div>' +
                                '</li>' +
                            '</ul>' +
                        '<div style="margin-top: 5px;" class="clearfix">' +
                            '<img id="spinner" style="display: block;margin-top:10px;float:left;margin-right: 10px" src="/images/grey-spinner.gif" />' +
                            '<span id="statusMessage" style="float:left;display: block;margin-top:15px;">Uploading files to server...</span>' +
                            '<input type="button" class="cancel-button" ng-click="cancelUpload()" value="Cancel"/>' +
                        '</div>' +
                        '</div>',
            scope: {
                flowObject: '='
            },
            link: function (scope, element, attributes) {

                scope.fileService = File;

                scope.cancelUpload = function () {
                    scope.flowObject.cancel();
                    element.remove();
                    scope.$destroy();
                }

                scope.flowObject.upload();
            }
        }
    }
]);
